import { useCallback, useEffect } from 'react';
import { subscribe, unsubscribe } from 'pubsub-js';
import { startConversation } from 'genesys/genesys';
import { DefinedError, useSetGenesysError } from 'genesys/error/error-state';
import { PubSubEvent } from 'genesys/pub-sub-events';
import { isLoggedInUser } from 'utils/isLoggedInUser';
import { useHasAgentConversationStarted } from 'state/hasAgentConversationStarted';
import { useMessagingServiceStatus } from 'genesys/useMessagingServiceStatus';
import { useHasUserInitiatedAuthChat } from 'state/hasUserInitiatedAuthChat';

export const startAConversation = ({ onFailure }) => {
  startConversation({
    retry: 3,
    onFailure,
  });
};

export const useStartConversation = () => {
  const setGenesysError = useSetGenesysError();
  const hasAgentConversationStarted = useHasAgentConversationStarted();
  const { setResetConversationLoading } = useMessagingServiceStatus();
  const hasUserInitiatedAuthChat = useHasUserInitiatedAuthChat();

  const handleStartConversationFailed = useCallback(() => {
    setGenesysError(
      isLoggedInUser()
        ? DefinedError.AuthConversationInitiateError
        : DefinedError.UnAuthConversationInitiateError,
    );
    setResetConversationLoading();
  }, [setGenesysError, setResetConversationLoading]);

  const handleMessagingServiceReady = useCallback(() => {
    if (
      isLoggedInUser() &&
      !!hasUserInitiatedAuthChat &&
      !hasAgentConversationStarted
    ) {
      startConversation({
        retry: 3,
        onFailure: handleStartConversationFailed,
      });
    }
  }, [
    hasUserInitiatedAuthChat,
    hasAgentConversationStarted,
    handleStartConversationFailed,
  ]);

  useEffect(() => {
    subscribe(PubSubEvent.MessageServiceReady, handleMessagingServiceReady);

    return () => {
      unsubscribe(handleMessagingServiceReady);
    };
  }, [handleMessagingServiceReady]);
};
